// packages/shared/src/reports.schemas.ts
import { z } from 'zod';

// AIDEV-NOTE: Schemas de relatorios — cliente e servidor devem usar a mesma validacao

export const ReportFilterSchema = z.object({
  // formato YYYY-MM, ex: "2026-03". Opcional — default = mes corrente no server
  periodo: z
    .string()
    .regex(/^\d{4}-\d{2}$/)
    .optional(),
  vendedorId: z.coerce.number().int().positive().optional(),
  clienteId: z.coerce.number().int().positive().optional(),
  status: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(500).default(100),
  offset: z.coerce.number().int().min(0).default(0)
});
export type ReportFilter = z.infer<typeof ReportFilterSchema>;

export const VendasReportRowSchema = z.object({
  vendedorId: z.number(),
  vendedorNome: z.string(),
  pedidos: z.number(),
  totalVendas: z.number(),
  metaMensal: z.number(),
  metaPercent: z.number().nullable()
});
export type VendasReportRow = z.infer<typeof VendasReportRowSchema>;

export const CRMReportRowSchema = z.object({
  estagio: z.string(),
  quantidade: z.number(),
  valorTotal: z.number(),
  taxaConversao: z.number() // percentual 0-100
});
export type CRMReportRow = z.infer<typeof CRMReportRowSchema>;

export const VisitasReportRowSchema = z.object({
  vendedorId: z.number(),
  vendedorNome: z.string(),
  totalVisitas: z.number(),
  visitasConcluidas: z.number(),
  duracaoMediaMin: z.number()
});
export type VisitasReportRow = z.infer<typeof VisitasReportRowSchema>;

// Shape generica de resposta paginada usada por todos os endpoints de relatorio
export const ReportResponseSchema = <T extends z.ZodTypeAny>(rowSchema: T) =>
  z.object({
    rows: z.array(rowSchema),
    total: z.number().int(),
    limit: z.number().int(),
    offset: z.number().int(),
    periodo: z.string()
  });

// AIDEV-NOTE: Helper type for paginated report responses used by service return types
export interface ReportResponse<T> {
  rows: T[];
  total: number;
  limit: number;
  offset: number;
  periodo: string;
}
